module.exports = __webpack_public_path__ + "img/15.c546942e.png";